import type { JSX } from 'react';
import { NavLink } from 'react-router';

import { NAV_ITEMS } from '@/app/navigation';
import { cn } from '@/lib/cn';

export function DesktopNavigation(): JSX.Element {
  return (
    <nav aria-label="Primary" className="hidden lg:block">
      <ul className="flex items-center gap-1">
        {NAV_ITEMS.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'relative inline-flex min-h-11 items-center rounded-md px-3 text-sm font-medium no-underline transition-colors duration-150',
                  isActive
                    ? 'text-text after:absolute after:inset-x-3 after:-bottom-0.5 after:h-0.5 after:rounded-full after:bg-accent'
                    : 'text-muted hover:bg-surface-muted hover:text-text',
                )
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
